module.exports = __webpack_public_path__ + "static/media/personal-historian.3e73a9d8.webp";